(() => {
  if (window.tootoBespokeBridgeInstalled) return;
  window.tootoBespokeBridgeInstalled = true;
  function mount(root) {
    if (root.dataset.tootoMounted) return;
    root.dataset.tootoMounted = 'true';
    const form = document.getElementById(root.dataset.tootoFormId);
    const slot = root.querySelector('[data-tooto-upload-slot]');
    const status = root.querySelector('[data-tooto-bridge-status]');
    const email = root.querySelector('[name="contact[email]"]');
    const steps = [...root.querySelectorAll('[data-tooto-step]')];
    const tabs = [...root.querySelectorAll('[data-tooto-go]')];
    const submit = root.querySelector(`button[type="submit"][form="${root.dataset.tootoFormId}"]`);
    const appId = root.dataset.tootoAppId;
    const retry = root.querySelector('[data-tooto-brief-retry]');
    const storageKey = `tooto-bespoke-draft:${location.pathname}:${root.dataset.tootoFormId}`;
    let current = 0, pending = false, saved = null, timer, finishTimer;
    let phase = 'idle', uploadEmail = '', triggeringApp = false, disposed = false;
    const appForm = () => slot.querySelector(`form[data-id="${appId}"]`);
    const hasFiles = () => [...slot.querySelectorAll('input[type="file"]')].some(input => input.files?.length) ||
      !!slot.querySelector('.gfb__dropzone--preview--area')?.children.length;
    const controls = () => [...form.elements].filter(control => /^contact\[/.test(control.name) &&
      !['contact[Request]', 'contact[Attachments]'].includes(control.name) && control.type !== 'file');
    const persist = () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          at: Date.now(), saved, phase, uploadEmail, hadFiles: hasFiles(),
          values: Object.fromEntries(controls().map(control => [control.name,
            control.type === 'checkbox' ? control.checked : control.value])),
        }));
      } catch { /* The current page remains usable when browser storage is unavailable. */ }
    };
    const setPhase = (next) => {
      phase = next;
      pending = next === 'uploading' || next === 'sending';
      submit.disabled = pending;
      retry.hidden = !next.endsWith('-unknown');
      retry.textContent = next === 'upload-unknown' ? 'Retry attachment submission' : 'Retry sending brief';
      form.setAttribute('aria-busy', String(pending));
      // Keep Globo's captcha usable; freeze our inputs without excluding them from the POST.
      steps.forEach(step => { step.inert = pending && (next === 'sending' || step.dataset.tootoStep !== '2'); });
      const notes = root.querySelector('[name="contact[body]"]');
      if (notes) notes.readOnly = pending;
    };
    const recover = (next) => {
      clearTimeout(timer);
      setPhase(next);
      status.textContent = next === 'upload-unknown'
        ? 'Attachment submission is not confirmed. Your text brief has not been sent. Check the upload form for errors or wait. Retrying may create a duplicate if the earlier request succeeded.'
        : 'Sending is not confirmed. Your draft and confirmed attachment status are retained in this tab. Check for a success message before retrying; the earlier request may already have succeeded.';
      slot.classList.remove('tooto-brief-connected');
      persist();
    };
    const show = (index) => {
      current = Math.max(0, Math.min(steps.length - 1, index));
      steps.forEach((step, i) => {
        step.hidden = i !== current;
        step.classList.toggle('tooto-brief-active', i === current);
      });
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === current)));
    };
    // Explicitly validate our controls, including controls outside the native
    // form linked by the form attribute. Do not rely on automatic validation:
    // Shopify/app scripts may set novalidate or dispatch submit themselves.
    const validateBrief = () => {
      const invalid = [...form.elements].find(control =>
        control.willValidate && !control.validity.valid
      );
      if (!invalid) return true;
      const step = invalid.closest('[data-tooto-step]');
      if (step) show(steps.indexOf(step));
      status.textContent = 'Please complete the required fields before sending your brief.';
      invalid.focus();
      invalid.reportValidity();
      return false;
    };
    // Guard the app's own submit/Enter/recovery paths too, before its handlers
    // can create an attachment submission with an incomplete contact brief.
    const guardAppSubmit = (event) => {
      const app = appForm();
      if (!app || !app.contains(event.target)) return;
      if (event.type === 'click' && !event.target.closest('.action.submit, button[type="submit"], input[type="submit"]')) return;
      if (triggeringApp || (phase === 'uploading' && event.type === 'submit')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (phase !== 'idle' || !validateBrief()) return;
      form.requestSubmit(submit);
    };
    slot.addEventListener('click', guardAppSubmit, true);
    slot.addEventListener('submit', guardAppSubmit, true);
    const sync = () => {
      const target = appForm()?.querySelector('input[name="email-1"]');
      if (!target) return false;
      if (target.value !== email.value) {
        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(target, email.value);
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (phase !== 'upload-unknown') slot.classList.add('tooto-brief-connected');
      return true;
    };
    const summary = (key, value) => {
      const node = root.querySelector(`[data-tooto-sum="${key}"]`);
      if (node) { node.textContent = value; node.classList.remove('tooto-brief-empty'); }
    };
    root.addEventListener('click', (event) => {
      if (pending) return;
      const button = event.target.closest('button');
      if (!button || slot.contains(button)) return;
      if (button.hasAttribute('data-tooto-go')) show(Number(button.dataset.tootoGo));
      if (button.hasAttribute('data-tooto-next')) show(current + 1);
      if (button.hasAttribute('data-tooto-back')) show(current - 1);
      const group = button.closest('[data-tooto-group]');
      if (!group) return;
      group.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const key = group.dataset.tootoGroup;
      const value = button.dataset.tootoLabel || button.textContent.trim();
      let input = form.querySelector(`[name="contact[${key}]"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `contact[${key}]`; form.append(input); }
      input.value = value;
      summary(key, value);
      persist();
    });
    email.addEventListener('input', sync);
    root.addEventListener('input', (event) => { if (event.target.form === form) persist(); });
    root.addEventListener('change', (event) => { if (event.target.form === form) persist(); });
    slot.addEventListener('change', (event) => {
      // App resets and synthetic email changes must not erase a confirmed submission.
      if (event.isTrusted && event.target.type === 'file' && phase === 'idle') { saved = null; persist(); }
    });
    // Observe asynchronous app rendering without reinitializing or replacing its upload widget.
    const observer = new MutationObserver(() => {
      if (phase === 'idle') sync();
      const preview = slot.querySelector('.gfb__dropzone--preview--area');
      summary('files', saved ? 'Saved in Globo' : preview?.children.length ? 'Added in upload form' : 'None added');
    });
    observer.observe(slot, { childList: true, subtree: true });
    root.addEventListener('invalid', (event) => {
      if (event.target.form !== form) return;
      const step = event.target.closest('[data-tooto-step]');
      if (step) show(steps.indexOf(step));
    }, true);
    const finish = () => {
      if (disposed) return;
      setPhase('idle');
      status.textContent = 'Attachments saved. Sending your brief…';
      show(3);
      form.requestSubmit(submit);
    };
    const onSubmitted = (event) => {
      if (!['uploading', 'upload-unknown'].includes(phase) || String(event.detail?.formId) !== appId || event.detail?.form !== appForm()) return;
      const continueSending = phase === 'uploading';
      saved = { email: uploadEmail };
      clearTimeout(timer);
      // Leave the upload state immediately so duplicate success events cannot queue another POST.
      setPhase(continueSending ? 'sending' : 'idle');
      persist();
      // Let Globo finish resetting its own form before the browser navigates.
      if (continueSending) finishTimer = setTimeout(finish, 0);
      else status.textContent = 'Attachments saved. Review your details and send your brief when ready.';
    };
    document.addEventListener('globo.formbuilder.form.submitted', onSubmitted);
    form.addEventListener('submit', (event) => {
      if (!validateBrief()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (phase !== 'idle' || window.Shopify?.designMode) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (window.Shopify?.designMode) status.textContent = 'Please test submission from the page preview, not inside the theme editor.';
        return;
      }
      persist();
      if (saved || !hasFiles()) {
        form.querySelector('[name="contact[Attachments]"]').value = saved
          ? `Attachments saved in Globo under ${saved.email}.` : 'No attachments.';
        setPhase('sending');
        status.textContent = 'Sending your brief…';
        persist();
        timer = setTimeout(() => recover('text-unknown'), 60000);
        return; // Native Shopify contact submission, including its spam protection.
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const app = appForm();
      const appSubmit = app?.querySelector('.gfb__footer .action.submit, button[type="submit"]');
      if (!sync() || !appSubmit || !window.Globo?.FormBuilder?.handleSubmit) {
        status.textContent = 'The attachment form has not loaded. Please wait and try again. Your brief has not been sent.';
        return;
      }
      uploadEmail = email.value;
      setPhase('uploading');
      persist();
      status.textContent = 'Saving attachments. Please keep this page open…';
      // Keep the app panel visible so its validation/captcha can be completed.
      show(2);
      timer = setTimeout(() => {
        if (phase === 'uploading') recover('upload-unknown');
      }, 60000);
      try {
        triggeringApp = true;
        appSubmit.click();
      } catch { recover('upload-unknown'); }
      finally { triggeringApp = false; }
    }, true);
    retry.addEventListener('click', () => {
      if (!phase.endsWith('-unknown')) return;
      const wasUpload = phase === 'upload-unknown';
      setPhase('idle');
      persist();
      if (wasUpload && !hasFiles()) {
        show(2);
        status.textContent = 'Please select your attachments again, or send your brief without attachments.';
        return;
      }
      form.requestSubmit(submit);
    });
    show(form.querySelector('.errors') ? 3 : 0);
    if (root.querySelector('[data-tooto-contact-success]')) {
      root.querySelector('.tooto-brief-brief-shell').hidden = true;
      try { sessionStorage.removeItem(storageKey); } catch { /* Storage may be disabled. */ }
    } else {
      try {
        const draft = JSON.parse(sessionStorage.getItem(storageKey));
        if (draft && Date.now() - draft.at < 24 * 60 * 60 * 1000) {
          saved = draft.saved?.email ? draft.saved : null;
          uploadEmail = draft.uploadEmail || '';
          for (const [name, value] of Object.entries(draft.values || {})) {
            if (!/^contact\[/.test(name) || ['contact[Request]', 'contact[Attachments]'].includes(name)) continue;
            let control = controls().find(item => item.name === name);
            if (!control) {
              const group = [...root.querySelectorAll('[data-tooto-group]')].find(item => `contact[${item.dataset.tootoGroup}]` === name);
              if (!group) continue;
              control = document.createElement('input'); control.type = 'hidden'; control.name = name; form.append(control);
              group.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.tootoLabel || button.textContent.trim()) === value)));
              summary(group.dataset.tootoGroup, value);
            }
            if (control.type === 'checkbox') control.checked = value === true;
            else control.value = value;
          }
          if (['uploading', 'upload-unknown'].includes(draft.phase)) recover('upload-unknown');
          else if (['sending', 'text-unknown'].includes(draft.phase) && !form.querySelector('.errors')) recover('text-unknown');
          else status.textContent = saved ? 'Draft restored. Your attachments are already saved.'
            : draft.hadFiles ? 'Draft restored. Please select your attachments again.' : 'Draft restored.';
        }
      } catch { /* Ignore unavailable storage or an invalid draft. */ }
    }
    const onPageShow = (event) => {
      if (event.persisted && phase === 'sending') recover('text-unknown');
    };
    window.addEventListener('pageshow', onPageShow);
    sync();
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      disposed = true;
      observer.disconnect(); clearTimeout(timer); clearTimeout(finishTimer);
      window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('globo.formbuilder.form.submitted', onSubmitted);
    });
  }
  const init = () => document.querySelectorAll('[data-tooto-bespoke-bridge]').forEach(mount);
  init();
  document.addEventListener('shopify:section:load', init);
})();
